@if (assessmentFilteredList!(); as list) {
  <table mat-table [dataSource]="list" class="mat-elevation-z8" aria-label="Assessment Liste">
    <ng-container matColumnDef="date">
      <th class="min-width" mat-header-cell *matHeaderCellDef>Zeitpunkt</th>
      <td class="min-width" mat-cell *matCellDef="let element">
        {{ element.dateIso | date: 'EEEEEE, dd.MM.yyyy' }}, {{ element.dateIso | date: 'shortTime' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="score">
      <th class="" mat-header-cell *matHeaderCellDef>Score</th>

      <td class="" mat-cell *matCellDef="let element">
        <!-- @if ((element | assessmentScorePercent) === -1) {
          <mat-progress-bar mode="buffer"></mat-progress-bar>
        } @else { -->
        <div class="score-vertical">
          <span>{{ element | assessmentScore }}</span>
          @if (element.type !== 'CUSTOM') {
            <span>{{ element | assessmentScorePercent }} %</span>
          }
        </div>
        <!-- } -->
      </td>
    </ng-container>
    <ng-container matColumnDef="score_left">
      <th class="no-wrap-column" mat-header-cell *matHeaderCellDef>Score links</th>

      <td class="no-wrap-column" mat-cell *matCellDef="let element">
        <!-- @if ((element | assessmentScorePercent) === -1) {
          <mat-progress-bar mode="buffer"></mat-progress-bar>
        } @else { -->
        <div class="score-vertical">
          <span>{{ element | assessmentScore: 'left' }}</span>
          @if (element.type !== 'CUSTOM') {
            <span>{{ element | assessmentScorePercent: 'left' }} %</span>
          }
        </div>
        <!-- } -->
      </td>
    </ng-container>
    <ng-container matColumnDef="score_right">
      <th class="no-wrap-column" mat-header-cell *matHeaderCellDef>Score rechts</th>

      <td class="no-wrap-column" mat-cell *matCellDef="let element">
        <!-- @if ((element | assessmentScorePercent) === -1) {
          <mat-progress-bar mode="buffer"></mat-progress-bar>
        } @else { -->
        <div class="score-vertical">
          <span>{{ element | assessmentScore: 'right' }}</span>
          @if (element.type !== 'CUSTOM') {
            <span>{{ element | assessmentScorePercent: 'right' }} %</span>
          }
        </div>
        <!-- } -->
      </td>
    </ng-container>
    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef>💬 Kommentar</th>
      <td class="note" mat-cell *matCellDef="let element">{{ element | assessmentNotes }}</td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let assessment">
        <div class="buttons">
          <mat-icon class="icon-button" (click)="navigateToAssessment(assessment)">edit</mat-icon>
          <!-- <button (click)="navigateToAssessment(assessment)" mat-button color="basic">
            <span class="uppercase small">Bearbeiten</span>
          </button> -->
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Kontext Menu öffnen">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button (click)="deleteAssessment(assessment)" mat-menu-item>
              <mat-icon>delete</mat-icon>
              <span>Löschen</span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
  </table>
}
